/*

Ashraf 11/28/2022 2698947782 converted fieldName to uppercase
Ashraf 11/29/2022  2698947782 fixed repo name uppercase
Ashraf 11/30/2022 2698947782 disabled data repo edit
Ashraf 11/30/2022 2698947782 fixed values reset issue
Ashraf 11/30/2022 2698947782 fixed field value issue
Ashraf 12/01/2022 2698947782 setting view only as empty when mandatory is checked
Poornima 12/01/2022 2698947782 fixed validations issue and messages
Ashraf 12/01/2022 2698947782 fixed page break issue on list items
Ashraf 12/01/2022 2698947782 fixed default date validations
Poornima 12/01/2022 2698947782 audit and is encrypted checkbox bugs fixed
Ashraf 12/03/2022 2698947782 fixed validations for list type
Ashraf 12/03/2022 2698947782 fixed type for list.
Ashraf 12/03/2022 2698947782 changed validation messages for min and max dates.
Ashraf 12/04/2022 2698947782 fixed date validations
Poornima 12/07/2022 2698947782 added auto highlight to field type
Poornima 12/07/2022 2698947782 added auto highlight to autocomplete fields
Poornima 12/12/2022 2698947782 added tooltip for multi select and chnaged audit note tooltip
Raghu 12/18/2022 2698947782 Fixed Validation message alignment issue
Ashraf 12/19/2022 2698947782 fixed validation message on date fields
Prakash 12/21/2022 2700753823 Fixed Validation value.
kavyareddy 12/23/2022 2698947782 Fixed deafult listType text
sai krishna 01/09/2023 2698947782 changed tooltip title
Suresh Peddavoora  01/13/2023 2698947782 Fixed Spacing issues for Textfields
Ashraf 02/01/2023 2698947782 fixed unsaved popup changes
Suresh Peddavoora 02/21/2023 2698947782 TextFields and table alignments
suresh peddavoora 02/24/2023 2698947782 New UI changes added
suresh peddavoora 02/28/2023 2698947782 Removed the class name custom-field-name for the fields
Rohini 03/02/2023 2698947782 commented input props
Raghu 03/14/2023 2698947782 added class name for input field
Prakash 03/17/2023 2698947782 fixed alignments in Responsive and desktop.
Prakash 10/04/2023 2698947782 fixed alignments in Responsive and desktop.
Sohel 05/29/2023 2698947782 Fixed Save button Issue
Sohel 09/24/2023 5155351299 Added Field Usage CheckBox
uday 25/025/2023 5155351299 fixed alignments in Responsive and desktop.
Sohel 09/26/2023 5155351299 Changed Labels and Fields Usage Payload
Sohel 09/27/2023 5155351299 Added DB Table Name Validation Based on repository Name
uday 09/29/2023 5155351299 Fixed validation issues
uday 10/03/2023 5155351299 fixed ui bug issues
Sohel 10/04/2023 5155351299 Added Criteria Field CheckBox
Sohel 10/04/2023 5155351299 Add Table Style based on Criteria Field
Sohel 10/04/2023 5155351299 Added Criteria Field CheckBox Based on Field Type
Sohel 10/04/2023 5155351299 Fixed Criteria Field Condition Issue
Sohel 10/05/2023 5155351299 Added Is Extendable Field
*/

import React, {useEffect, useState, useContext} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {useRef} from 'react';
import {useSelector} from 'react-redux';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
  makeStyles,
} from '@material-ui/core';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {Currency} from '../../../../../util/Currency';
import NumberFormat from 'react-number-format';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {removeSpecialCharacters} from './AddDataRepoForm';
const useStyles = makeStyles((theme) => ({
  taskParameters: {
    border: '1px dashed',
    padding: '18px 10px 0px 10px',
    position: 'relative',
    marginBottom: '15px',
    borderRadius: '4px',
  },
}));
const fieldUsage = [
  {
    value: 'IMPORT',
  },
  {
    value: 'TRIGGER',
  },
  {
    value: 'WORK_QUEUE',
  },
  {
    value: 'REPORT',
  },
  {
    value: 'EXPORT',
  },
];
const FormFields = ({
  setFormData,
  formData,
  handleClose,
  dbRef,
  data,
  setEditable,
  editable,
  viewSet,
  field,
  windowId,
  windowNumber,
  isCopyRowData,
  udwView,
  isEditMode,
  rowData,
  isAddOpen,
  setNewLookupField,
  isEditOpen,
  oldFieldName,
  fieldOperation,
  maxSequence,
  editExisting,
  setMaxSequence,
  setFieldOperation,
  setOldFieldName,
  lookupValuesData,
  setLookupValuesData,
  setDeletedFieldIds,
  dirtyRef,
  isCriteria,
  isAlreadyExtended,
}) => {
  const [fieldType, setFieldType] = useState(null);
  const {reusableInputStyles} = useContext(ThemeContext);
  const [minLabel, setMinLabel] = useState('Minimum Length');
  const [maxLabel, setMaxLabel] = useState('Maximum Length');
  const [dataBaseValue, setDataBaseValue] = useState('');
  const componentClasses = useStyles();
  const formRef = useRef();

  // handling field type state (2699250881)
  const handleFieldType = (value) => {
    setFieldType(value);
    if (value === 'Number' || value === 'Amount') {
      setMinLabel('Minimum Value');
      setMaxLabel('Maximum Value');
    } else {
      setMinLabel('Minimum Length');
      setMaxLabel('Maximum Length');
    }
  };

  // setting field type when editing a field (2699250881)
  useEffect(() => {
    if (data?.fieldType) {
      handleFieldType(data?.fieldType);
    }
  }, []);
  const [items, setItems] = useState(
    data?.listValue && data?.listType === 'Fixed' ?
      data?.listValue?.split(',') :
      data?.listValue ?
        data?.listValue :
        [],
  );
  const [item, setItem] = useState('');
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [view, setView] = useState(udwView || data?.displayOptions?.isEditable === 'N');
  // const [isDropdownChecked, setIsDropdownChecked] = useState(data?.isList === 'Dropdown');
  const isDropdownChecked = data?.isList === 'Dropdown'
  const {typeCodeDropdownData} = useSelector(({userDefinedWindow}) => userDefinedWindow);

  const fieldTypeOptions = [
    {key: 'Amount', value: 'Amount'},
    {key: 'Date', value: 'Date'},
    {key: 'Number', value: 'Number'},
    {key: 'Phone', value: 'Phone'},
    {key: 'SSN', value: 'SSN'},
    {key: 'string', value: 'Text'},
    {key: 'Email', value: 'Email'},
  ];

  const listTypeOptions = ['Not A List', 'Fixed', 'Dynamic'];

  // setting initial value for field type (2699250881)
  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.key?.toLowerCase() === option?.toLowerCase() || item?.typeCode === option) {
          label = item;
        }
      });
    return label;
  };

  // initial values for form (2699250881)
  const initialValues = {
    fieldName: data && data?.fieldName ? data?.fieldName : '',
    fieldLabel: data && data?.fieldLabel ? data?.fieldLabel : '',
    dbColumnName: data && data?.dbColumnName ? data?.dbColumnName : '',
    lookupField: data?.isLookUp ? data.isLookUp === 'Y' : false,
    fieldType:
      (data && data?.isList && data?.isList === 'Y') ||
      data?.fieldType === 'string' ||
      data?.fieldType === 'Text' ||
      data?.fieldType === 'text' ?
        getObject('string', fieldTypeOptions) :
        data && data?.fieldType ?
          getObject(data?.fieldType, fieldTypeOptions) :
          'none',
    minimum:
      data?.fieldType?.toLowerCase() !== 'date' && data?.minValue ?
        data?.minValue :
        data?.minLength ?
          data?.minLength :
          null,
    // data?.validations
    //   ? getValue(data?.validations, "min")
    //   : fieldType === "Amount" || fieldType === "Number"
    //     ? null
    //     : "",
    maximum:
      data?.fieldType?.toLowerCase() !== 'date' && data?.maxValue ?
        data?.maxValue :
        data?.maxLength ?
          data?.maxLength :
          null,
    // data?.validations ? getValue(data?.validations, "max") : "",
    minDate:
      data?.fieldType?.toLowerCase() === 'date' && data?.minValue ?
        moment(data?.minValue).format('MM/DD/YYYY') :
        null,
    maxDate:
      data?.fieldType?.toLowerCase() === 'date' && data?.maxValue ?
        moment(data?.maxValue).format('MM/DD/YYYY') :
        null,
    mandatory: data && data?.isMandatory ? data?.isMandatory === 'Y' : false,
    viewOnly: data && data?.viewOnly ? data?.viewOnly === 'Y' : false,
    auditTrail: data && data?.isAuditTrail ? data?.isAuditTrail === 'Y' : false,
    auditNote: data && data?.isAuditNote ? data?.isAuditNote === 'Y' : false,
    unique: data && data?.isUnique ? data?.isUnique === 'Y' : false,
    isList: data && data?.isList ? data?.isList === 'Y' : false,
    isDropdown: data && data?.isList ? data?.isList === 'Dropdown' : false,
    dataBaseReference: data && data?.globalFieldName ? data?.globalFieldName : '',
    list: '',
    typeCode:
      data && data?.listType === 'Dynamic' ? getObject(data?.listValue, typeCodeDropdownData) : '',
    listType: data && data?.listType ? data?.listType : listTypeOptions[0],
    isEncrypted: data && data?.isEncrypted ? data?.isEncrypted === 'Y' : false,
    isIndexed: data && data?.isIndexed ? data?.isIndexed === 'Y' : false,
    multiSelect: data && data?.multiSelect ? data?.multiSelect === 'Y' : false,
    IMPORT: data && data?.IMPORT ? data?.IMPORT === 'Y' : true,
    EXPORT: data && data?.EXPORT ? data?.EXPORT === 'Y' : true,
    WORK_QUEUE: data && data?.WORK_QUEUE ? data?.WORK_QUEUE === 'Y' : true,
    TRIGGER: data && data?.TRIGGER ? data?.TRIGGER === 'Y' : true,
    REPORT: data && data?.REPORT ? data?.REPORT === 'Y' : true,
    isCriteriaField: data && data?.isCriteriaField ? data?.isCriteriaField === 'Y' : false,
  };

  // setting reference value when editing a field (2699250881)
  useEffect(() => {
    setDataBaseValue(data?.globalFieldName);
  }, [data]);

  // adding a field to the fields table (2699250881)
  const handleSubmit = (values) => {
    dirtyRef.current = true;
    const fetchedFields = editable?.length > 0 ? [...editable] : [];
    const filterFetchedData = editable.filter((item) => {
      return item?.sequenceNo === data.sequenceNo;
    });
    const copyData = [...formData];
    const filteredData = formData?.filter((item) => {
      return item?.sequenceNo === data.sequenceNo;
    });
    let validations = [];

    // setting validations based on given configurations (2699250881)
    if (values.mandatory) {
      validations.push({
        type: 'required',
        params: [`${values.fieldLabel} is required`],
      });
    }
    if (values.minimum && values.fieldType?.key === 'string') {
      validations.push({
        type: 'min',
        params: [
          values.minimum,
          `${values.fieldLabel} cannot be less than ${values.minimum} characters`,
        ],
      });
    }
    if (values.minDate && values.fieldType?.key === 'Date') {
      const date = moment(values?.minDate).format('MM/DD/YYYY');
      validations.push({
        type: 'min',
        params: [date, `${values.fieldLabel} cannot be less than ${date}`],
      });
    }
    if (values.maxDate && values.fieldType?.key === 'Date') {
      const date = moment(values?.maxDate).format('MM/DD/YYYY');
      validations.push({
        type: 'max',
        params: [date, `${values.fieldLabel} cannot be greater than ${date}`],
      });
    }
    if (
      values.maximum &&
      (values.fieldType?.key === 'Number' || values.fieldType?.key === 'Amount')
    ) {
      validations.push({
        type: 'max',
        params: [
          values.maximum,
          `${values.fieldLabel} cannot exceed ${values?.fieldType?.key === 'Amount' ? `$` : ''} ${
            values.maximum
          } ${values?.fieldType?.key === 'Number' ? `digits` : ''}`,
        ],
      });
    }
    if (
      values.minimum &&
      (values.fieldType?.key === 'Number' || values.fieldType?.key === 'Amount')
    ) {
      validations.push({
        type: 'min',
        params: [
          values.minimum,
          `${values.fieldLabel} cannot be less than ${
            values?.fieldType?.key === 'Amount' ? `$` : ''
          } ${values.minimum} ${values?.fieldType?.key === 'Number' ? `digits` : ''}`,
        ],
      });
    }
    if (values.fieldType?.key === 'Date') {
      validations.push({
        type: 'typeError',
        params: [`Invalid Date Format`],
      });
    }
    if (!values.mandatory || values.fieldType?.key === 'Date') {
      validations.push({
        type: 'nullable',
        params: [],
      });
    }
    if (values.maximum && values.fieldType?.key === 'string') {
      validations.push({
        type: 'max',
        params: [values.maximum, `${values.fieldLabel} cannot exceed ${values.maximum} characters`],
      });
    }
    if (values.fieldType?.key === 'Email') {
      validations.push({
        type: 'email',
        params: [`${values.fieldLabel} is invalid`],
      });
    }

    if (values?.listType !== 'Not A List') {
      validations = [];
      if (values?.mandatory) {
        validations.push({
          type: 'required',
          params: [`${values.fieldLabel} is required`],
        });
      }
    }

    const getLabel = (value) => {
      if (value) {
        return 'Y';
      }
      return 'N';
    };

    // setting field payload wih entered values (2699250881)
    const formValues = {
      fieldId: data?.fieldId ? data?.fieldId : 0,
      sequenceNo: filteredData.length > 0 ? filteredData[0].sequenceNo : copyData.length + 1,
      fieldName: values?.fieldName,
      fieldLabel: values.fieldLabel,
      fieldType:
        values && values?.isList ?
          'dropdown' :
          values.fieldType?.key === 'string' ?
            'Text' :
            values.fieldType?.key,
      validationType:
        values.listType?.toLowerCase() !== 'not a list' ?
          'mixed' :
          (values.fieldType?.key === 'string' || 'Number') && values.isList ?
            'mixed' :
            (values.fieldType?.key === 'string' ||
              values.fieldType?.key === 'Email' ||
              values.fieldType?.key === 'Phone' ||
              values.fieldType?.key === 'SSN') &&
            !values.isList ?
              'string' :
              values.fieldType?.key === 'Date' ?
                'date' :
                values.fieldType?.key === 'Amount' ?
                  'number' :
                  values.fieldType?.key === 'Number' ?
                    'string' :
                    null,
      lookupType: data?.lookupType ? data?.lookupType : '',
      isLookUp: values?.lookupField ? 'Y' : 'N',
      isActive: 'Y',
      isList: values.isList ? 'Y' : values?.isDropdown ? 'Dropdown' : 'N',
      listValue:
        items.length > 0 && values?.listType === 'Fixed' ?
          items?.toString() :
          values?.typeCode && values?.listType === 'Dynamic' ?
            values?.typeCode?.typeCode :
            '',
      listType: values?.listType ? values?.listType : '',
      isMandatory: values.isEditable ? 'N' : getLabel(values.mandatory),
      validations: validations,
      dbColumnName: values?.dbColumnName,
      globalFieldName: dataBaseValue ? dataBaseValue : '',
      typeCode: values?.typeCode ? values?.typeCode?.typeCode : '',
      maximumLength: values.maximum,
      maxLength: values?.fieldType?.value?.toLowerCase() === 'text' ? values?.maximum : '',
      maxValue:
        values?.fieldType?.value?.toLowerCase() === 'date' &&
        values?.listType === 'Not A List' &&
        values?.maxDate ?
          moment(values?.maxDate).format('MM/DD/YYYY') :
          values?.fieldType?.value?.toLowerCase() === 'amount' ||
            values?.fieldType?.value?.toLowerCase() === 'number' ?
            values?.maximum :
            '',
      minLength: values?.fieldType?.value?.toLowerCase() === 'text' ? values?.minimum : '',
      minValue:
        values?.fieldType?.value?.toLowerCase() === 'date' &&
        values?.listType === 'Not A List' &&
        values?.minDate ?
          moment(values?.minDate).format('MM/DD/YYYY') :
          values?.fieldType?.value?.toLowerCase() === 'amount' ||
            values?.fieldType?.value?.toLowerCase() === 'number' ?
            values?.minimum :
            '',
      viewOnly: values.viewOnly ? 'Y' : 'N',
      minimumLength: values.minimum,
      isEncrypted: getLabel(values.isEncrypted),
      isIndexed: getLabel(values.isIndexed),
      multiSelect: getLabel(values.multiSelect),
      isExtended: getLabel(values.isExtended),
      isEditable: getLabel(!values.viewOnly),
      isUnique: getLabel(values.unique),
      isHidden: getLabel(values.isHidden),
      isAuditNote: getLabel(values.auditNote),
      isAuditTrail: getLabel(values.auditTrail),
      isTrackChanges: getLabel(values.isTrackChanges),
      EXPORT: values?.EXPORT ? 'Y' : 'N',
      IMPORT: values?.IMPORT ? 'Y' : 'N',
      WORK_QUEUE: values?.WORK_QUEUE ? 'Y' : 'N',
      TRIGGER: values?.TRIGGER ? 'Y' : 'N',
      REPORT: values?.REPORT ? 'Y' : 'N',
      isCriteriaField: values?.isCriteriaField ? 'Y' : 'N',
    };
    if (editExisting) {
      formValues.sequenceNo = data?.sequenceNo ? data?.sequenceNo : fetchedFields?.length + 1;
      formValues.oldFieldName = !data?.windowFieldId ? '' : oldFieldName ? oldFieldName : '';
      formValues.fieldOperation = data?.windowFieldId ? 'E' : fieldOperation ? fieldOperation : 'N';
    }

    if (filteredData.length > 0) {
      copyData.splice(filteredData[0]?.tableData?.id, 1, formValues);
    } else {
      copyData.push(formValues);
    }
    if (filterFetchedData.length > 0) {
      fetchedFields.splice(filterFetchedData[0]?.tableData?.id, 1, formValues);
    } else {
      fetchedFields.push(formValues);
    }
    setEditable(fetchedFields);
    setFormData(copyData);
    handleClose();
  };
  //   AMT, CHR, DRV, DTE, FN1-FN22, KEY, NBR, PRT, SSN
  const classes = reusableInputStyles();

  // used to prevent entering spaces in fields (2699250881)
  const handleKeyDown = (evt) => {
    if (['Enter', 'Tab', ','].includes(evt.key)) {
      evt.preventDefault();
      const value = item.trim();
      if (value) {
        setItems([...items, value]);
        setItem('');
      }
    }
  };

  // handling list item change for list field (2699250881)
  const handleItemChange = (e) => {
    setItem(e.target.value);
  };

  // handling delete list item for list field (2699250881)
  const handleDelete = (item) => {
    setItems(items.filter((i) => i !== item));
  };

  // revalidate after reference selection (2699250881)
  useEffect(() => {
    dataBaseValue && formRef?.current?.setFieldValue('dataBaseReference', dataBaseValue);
  }, [dataBaseValue]);

  // number formatter used for number field (2699250881)
  function NumberFormatter(props) {
    const {inputRef, onChange, ...other} = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        isNumericString
        decimalScale={0}
        allowNegative={false}
      />
    );
  }

  // checking if field label exist for validation (2699250881)
  const getFieldLabel = (value, data) => {
    const ar = [];
    const val = value?.toLowerCase()?.replaceAll(' ', '');
    const editLabel = rowData?.fieldLabel?.toLowerCase()?.replaceAll(' ', '');
    data &&
      data?.map((i) => {
        if (isEditMode && val !== editLabel) {
          i?.fieldLabel?.toLowerCase()?.replaceAll(' ', '') === val && ar.push(i);
        } else if (!isEditMode) {
          i?.fieldLabel?.toLowerCase()?.replaceAll(' ', '') === val && ar.push(i);
        }
      });
    return ar.length > 0;
  };

  const getFieldName = (value, data) => {
    const ar = [];
    const val = value?.toLowerCase()?.replaceAll(' ', '');
    const editLabel = rowData?.fieldName?.toLowerCase()?.replaceAll(' ', '');
    data &&
      data?.length > 0 &&
      data?.map((i) => {
        if (isEditMode && val !== editLabel) {
          i?.fieldName?.toLowerCase()?.replaceAll(' ', '') === val && ar.push(i);
        } else if (!isEditMode) {
          i?.fieldName?.toLowerCase()?.replaceAll(' ', '') === val && ar.push(i);
        }
      });
    return ar.length > 0;
  };

  // validations for form fields (2699250881)
  const schema = Yup.object().shape(
    {
      fieldLabel:
        !windowNumber || isCopyRowData ?
          Yup.string()
            .test('fieldLabel', 'Field Label already exist', (value) => {
              if (value && value.length > 0 && getFieldLabel(value, formData)) {
                return false;
              } else {
                return true;
              }
            })
            .required('Field Label is required') :
          Yup.string()
            .test('fieldLabel', 'Field Label already exist', (value) => {
              if (value && value.length > 0 && getFieldLabel(value, editable)) {
                return false;
              } else {
                return true;
              }
            })
            .required('Field Label is required'),
      fieldName:
        !windowNumber || isCopyRowData ?
          Yup.string()
            .test('fieldName', 'Field Name already exist', (value) => {
              if (value && value.length > 0 && getFieldName(value, formData)) {
                return false;
              } else {
                return true;
              }
            })
            .required('Field Name is required') : // .matches(/^[a-zA-Z0-9\_]+$/, "Only alphabets, numbers and underscore(_) are allowed")
        // .matches(
        //   cannotStartWithNumberRegex,
        //   "Field name cannot start with number or special character"
        // )
          Yup.string()
            .test('fieldName', 'Field Name already exist', (value) => {
              if (value && value.length > 0 && getFieldName(value, editable)) {
                return false;
              } else {
                return true;
              }
            })
            .required('Field Name is required'),
      dbColumnName: Yup.string()
        .matches(
          /^[a-z0-9_]+$/,
          'Please use only the English letters (A-Z, a-z), numerals (0-9) and _',
        )
        .required('DB Column Name is required'),
      fieldType:
        !isDropdownChecked &&
        Yup.mixed().test('fieldType', 'Field Type is required', (value) => {
          if (!value?.value) {
            return false;
          } else {
            return true;
          }
        }),
      dataBaseReference:
        fieldType === 'Reference' &&
        !dataBaseValue &&
        Yup.string().test('dataBaseReference', 'Reference is required', (val) => {
          return dataBaseValue;
        }),
      maximum: Yup.number()
        .when('minimum', (minimum, schema) => {
          return minimum > 0 ?
            schema.min(Yup.ref('minimum'), `${maxLabel} cannot be less than ${minLabel}`) :
            schema.nullable();
        })
        .nullable(true)
        .transform((value) =>
          value === '' || value === null || value === undefined || value !== Number(value) ?
            null :
            value,
        ),
      // minimum: Yup.number().when("maximum", {
      //   is: (value) => value && value.toString().length > 0,
      //   then: Yup.number()
      //     .test("minimum", `${minLabel} cannot be greater than or equal to ${maxLabel}`, function(value) {
      //       const { parent } = this;
      //       if (parent?.minimum > 0 && (parent?.minimum >= parent?.maximum)) {
      //         return false;
      //       } else {
      //         return true;
      //       }
      //     }),
      //   otherwise: Yup.number().nullable(),
      // }),
      list: Yup.object()
        .test('list', 'List is required', function(value, context) {
          const {parent} = context;
          if (parent.listType === 'Fixed' && items?.length < 1) {
            return false;
          } else {
            return true;
          }
        })
        .nullable(),
      typeCode: Yup.object()
        .test('typeCode', 'Type is required', function(value, context) {
          const {parent} = context;
          if (parent.listType === 'Dynamic' && !parent?.typeCode?.typeCode) {
            return false;
          } else {
            return true;
          }
        })
        .nullable(),
      minDate: Yup.date()
        .min('01/01/1900', 'Invalid Date')
        .max('01/01/2100', 'Invalid Date')
        .typeError('Invalid date Format')
        .nullable(),
      maxDate: Yup.date()
        .min('01/01/1900', 'Invalid Date')
        .max('01/01/2100', 'Invalid Date')
        // .test("maxDate", "Maximum date cannot be less than Minimum date", function (value) {
        //   const { parent } = this;
        //   console.log(moment(parent.maxDate).format("MM/DD/YYYY") > moment(parent.minDate).format("MM/DD/YYYY"));
        //   if (parent.minDate && parent.maxDate && (moment(parent.maxDate).format("MM/DD/YYYY") < moment(parent.minDate).format("MM/DD/YYYY"))) {
        //     return false;
        //   } else {
        //     return true;
        //   }
        // })
        .min(Yup.ref('minDate'), 'Maximum Date cannot be less than Minimum Date')
        .typeError('Invalid date Format')
        .nullable(),
    },

    ['maximum', 'minimum', 'list', 'typeCode'],
  );
  useEffect(() => {
    setDisableSubmit(false);
  }, []);
  const criteriaFieldSelected = (fields) => {
    let selected = false;
    fields?.forEach((el) => {
      if (['Y', true]?.includes(el?.isCriteriaField) && !isEditMode) {
        selected = true;
      } else if (
        ['N', false]?.includes(data?.isCriteriaField) &&
        isEditMode &&
        ['Y', true]?.includes(el?.isCriteriaField)
      ) {
        selected = true;
      }
    });
    return selected;
  };
  return (
    <div className={classes.dialoguecardStyles}>
      <Formik
        onSubmit={(values) => {
          setDisableSubmit(true);
          handleSubmit(values);
        }}
        innerRef={formRef}
        onReset={(values) => {
          if (data?.fieldType === 'Number' || data?.fieldType === 'Amount') {
            setMinLabel('Minimum Value');
            setMaxLabel('Maximum Value');
          } else {
            setMinLabel('Minimum Length');
            setMaxLabel('Maximum Length');
          }
          setFieldType(isEditOpen ? data?.fieldType : null);
          setItems(
            data?.listValue && data?.listType === 'Fixed' ? data?.listValue?.split(',') : [],
          );
          setItem('');
          values = initialValues;
        }}
        initialValues={initialValues}
        validationSchema={schema}
      >
        {(props) => {
          const {
            values,
            handleChange,
            handleSubmit,
            handleBlur,
            handleReset,
            setFieldValue,
            touched,
            setFieldTouched,
            errors,
          } = props;
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
              <div className="form-row global-field-textfields new-standard-textfields mt-2">
                <div
                  className={`${
                    errors?.fieldName?.length > 50 ?
                      'form-group col-sm-4 custom-field-name pb-1' :
                      'form-group col-sm-4'
                  }`}
                >
                  <TextField
                    margin="dense"
                    variant="outlined"
                    className={`${classes.labelName}`}
                    placeholder={`Enter Field Name`}
                    label="Field Name"
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    disabled={data?.fieldName}
                    name="fieldName"
                    autoFocus={true}
                    onChange={(e) => {
                      handleChange(e);
                      const tableName = removeSpecialCharacters(e.target.value);
                      setFieldValue('dbColumnName', tableName?.toLowerCase()?.replaceAll(' ', '_'));
                      setFieldValue('fieldName', e.target.value);
                    }}
                    required
                    value={values?.fieldName}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.fieldName}
                    error={Boolean(touched.fieldName && errors.fieldName)}
                  />
                  <FormHelperText>{errors.fieldName}</FormHelperText>
                </div>
                <div className="form-group col-sm-4">
                  <TextField
                    margin="dense"
                    variant="outlined"
                    className={`${classes.labelName}`}
                    placeholder={`Enter Field Label`}
                    label="Field Label"
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="fieldLabel"
                    value={values.fieldLabel}
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.fieldLabel}
                    error={Boolean(touched.fieldLabel && errors.fieldLabel)}
                  />
                  <FormHelperText>{touched.fieldLabel && errors.fieldLabel}</FormHelperText>
                </div>
                {!values?.isDropdown && (
                  <div className="form-group col-sm-4">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="fieldType"
                      size="small"
                      options={fieldTypeOptions}
                      fullWidth
                      className="select-gender"
                      label="Field Type"
                      autoHighlight
                      required
                      value={values.fieldType || 'none'}
                      onBlur={handleBlur}
                      disabled={data?.fieldType}
                      getOptionLabel={(option) => option.value}
                      renderInput={(params) => (
                        <GuiTextField
                          {...params}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          name="fieldType"
                          error={Boolean(touched?.fieldType && errors?.fieldType)}
                          required
                          label="Field Type"
                          className={`${classes.labelName}`}
                          variant="outlined"
                          margin="dense"
                          placeholder="Select Field Type"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off', // disable autocomplete and autofill
                          }}
                        />
                      )}
                      error={touched?.fieldType && errors?.fieldType}
                      touched={touched?.fieldType}
                      onChange={(event, value) => {
                        setFieldValue('fieldType', value).then(() => {
                          values.fieldType === 'none' && setFieldValue('fieldType', value);
                          handleFieldType(value?.value);
                          setFieldValue('isList', false);
                          setFieldValue('lookupField', false);
                          setFieldValue('minimum', '');
                          setFieldValue('maximum', '');
                          setItems([]);
                          if (!udwView) {
                            setView(false);
                            setFieldValue('viewOnly', false);
                          }
                          if (value?.value === 'Reference') {
                            setFieldValue('viewOnly', true) && setView(true);
                            setFieldValue('unique', false);
                          }
                          if (data && Object.keys(data).length > 0) {
                            data['fieldType'] = value?.value;
                            value?.value !== 'Reference' &&
                              setFieldValue('dataBaseReference', '') &&
                              (data['globalFieldName'] = '');
                          }
                        });
                      }}
                    />
                    {errors?.fieldType ? (
                      <FormHelperText>{touched.fieldType && errors.fieldType}</FormHelperText>
                    ) : null}
                  </div>
                )}
                <div
                  className={`${
                    touched.dbColumnName && errors?.dbColumnName?.length > 40 ?
                      'form-group col-sm-4  custom-field-name pb-1' :
                      'form-group col-sm-4'
                  }`}
                >
                  <TextField
                    margin="dense"
                    variant="outlined"
                    className={`${classes.labelName}`}
                    placeholder={`Enter DB Column Name`}
                    label="DB Column Name"
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    disabled={data?.dbColumnName}
                    name="dbColumnName"
                    value={values.dbColumnName}
                    onChange={(e) => {
                      setFieldValue(
                        'dbColumnName',
                        e?.target?.value?.toLowerCase()?.replaceAll(' ', '_'),
                      );
                    }}
                    onBlur={handleBlur}
                    fullWidth
                    required
                    touched={touched.dbColumnName}
                    error={Boolean(touched.dbColumnName && errors.dbColumnName)}
                  />
                  <FormHelperText>{touched.dbColumnName && errors.dbColumnName}</FormHelperText>
                </div>
                {values?.fieldType?.value !== 'Reference' && (
                  <div className="form-group col-sm-4">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="listType"
                      size="small"
                      options={listTypeOptions?.length > 0 ? listTypeOptions : []}
                      fullWidth
                      className="select-gender"
                      label="List Type"
                      value={values?.listType}
                      onBlur={handleBlur}
                      autoHighlight
                      getOptionLabel={(option) => option}
                      renderInput={(params) => (
                        <GuiTextField
                          {...params}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          name="listType"
                          error={Boolean(touched?.listType && errors?.listType)}
                          label="List Type"
                          className={`${classes.labelName}`}
                          variant="outlined"
                          margin="dense"
                          placeholder="Select List Type"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off', // disable autocomplete and autofill
                          }}
                        />
                      )}
                      error={touched?.listType && errors?.listType}
                      touched={touched?.listType}
                      onChange={(event, value) => {
                        setItems([]);
                        setFieldValue('listType', value);
                      }}
                    />
                    {errors?.listType ? (
                      <FormHelperText>{touched.listType && errors.listType}</FormHelperText>
                    ) : null}
                  </div>
                )}
                {!(
                  // render maximum, minimum fields only for number, amount type (2699250881)
                  (
                    fieldType === 'Date' ||
                    fieldType === 'SSN' ||
                    fieldType === 'Reference' ||
                    fieldType === 'Email' ||
                    fieldType === 'Phone'
                  )
                ) &&
                  !(
                    data?.fieldType === 'Date' ||
                    data?.fieldType === 'SSN' ||
                    data?.fieldType === 'Reference' ||
                    data?.fieldType === 'Email' ||
                    data?.fieldType === 'Phone'
                  ) &&
                  values?.listType === 'Not A List' &&
                  !values?.viewOnly && (
                  <>
                    {!view && !values?.isDropdown && (
                      <div className="form-group col-sm-4">
                        <TextField
                          margin="dense"
                          variant="outlined"
                          className={`${classes.labelName}`}
                          // className={
                          //   fieldType === "Amount"
                          //     ? `${classes.labelName} ${classes.inputLabel} ${classes.amountLabel}`
                          //     : `${classes.labelName} ${classes.inputLabel}`
                          // }
                          placeholder={`Enter ${minLabel}`}
                          label={minLabel}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          InputProps={{
                            startAdornment: fieldType === 'Amount' && (
                              <InputAdornment className="doller-placement" position="start">
                                  $
                              </InputAdornment>
                            ),
                            inputComponent: fieldType === 'Amount' ? Currency : NumberFormatter,
                          }}
                          name="minimum"
                          value={values.minimum}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.minimum}
                          error={Boolean(errors.minimum)}
                        />
                        <FormHelperText>{errors.minimum}</FormHelperText>
                      </div>
                    )}
                    {!view && !values?.isDropdown && (
                    // render if not view only field (2699250881)
                      <div className="col-sm-4 user-login-fields">
                        <TextField
                          margin="dense"
                          variant="outlined"
                          className={`${classes.labelName}`}
                          // className={
                          //   fieldType === "Amount"
                          //     ? `${classes.labelName} ${classes.inputLabel} ${classes.amountLabel}`
                          //     : `${classes.labelName} ${classes.inputLabel}`
                          // }
                          placeholder={`Enter ${maxLabel}`}
                          label={maxLabel}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          InputProps={{
                            startAdornment: fieldType === 'Amount' && (
                              <InputAdornment className="doller-placement" position="start">
                                  $
                              </InputAdornment>
                            ),
                            inputComponent: fieldType === 'Amount' ? Currency : NumberFormatter,
                          }}
                          onKeyDown={() => setFieldTouched('maximum')}
                          name="maximum"
                          value={values.maximum}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.maximum}
                          error={Boolean(touched.maximum && errors.maximum)}
                        />
                        <FormHelperText>{touched.maximum && errors.maximum}</FormHelperText>
                      </div>
                    )}
                  </>
                )}
                {
                  // render maximum, minimum fields only for date type (2699250881)
                  (fieldType === 'Date' || data?.fieldType === 'Date') &&
                    values?.listType === 'Not A List' &&
                    !values?.viewOnly && (
                    <>
                      {!view && !values?.isDropdown && (
                        <div className="form-group col-sm-4">
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Grid container>
                              <KeyboardDatePicker
                                name={'minDate'}
                                autoOk
                                className={`${classes.labelName}`}
                                // className={`${classes.datePicker} ${classes.labelName}`}
                                margin="dense"
                                inputVariant="outlined"
                                format="MM/dd/yyyy"
                                helperText={''}
                                placeholder="MM/DD/YYYY"
                                fullWidth
                                // InputLabelProps={{
                                //   shrink: true,
                                // }}
                                label={'Minimum Date'}
                                value={values.minDate}
                                onChange={(val) => {
                                  setFieldValue('minDate', val);
                                }}
                                onBlur={handleBlur}
                                touched={touched.minDate}
                                error={Boolean(touched.minDate && errors.minDate)}
                              />
                            </Grid>
                          </MuiPickersUtilsProvider>
                          <FormHelperText>{touched.minDate && errors.minDate}</FormHelperText>
                        </div>
                      )}
                      {!view && !values?.isDropdown && (
                      // render if not view only field (2699250881)
                        <div className=" col-sm-4 new-standard-textfields user-login-fields">
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Grid container>
                              <KeyboardDatePicker
                                // onChange={(val) => setFieldValue("minDate", val)}
                                name={'maxDate'}
                                autoOk
                                className={`${classes.labelName}`}
                                // className={`${classes.datePicker} ${classes.labelName}`}
                                margin="dense"
                                helperText={''}
                                inputVariant="outlined"
                                format="MM/dd/yyyy"
                                placeholder="MM/DD/YYYY"
                                fullWidth
                                // InputLabelProps={{
                                //   shrink: true,
                                // }}
                                label={'Maximum Date'}
                                value={values.maxDate}
                                onChange={(val) => {
                                  setFieldValue('maxDate', val);
                                }}
                                onBlur={handleBlur}
                                touched={touched.maxDate}
                                error={Boolean(touched.maxDate && errors.maxDate)}
                              />
                            </Grid>
                          </MuiPickersUtilsProvider>
                          <FormHelperText>{touched.maxDate && errors.maxDate}</FormHelperText>
                        </div>
                      )}
                    </>
                  )
                }
                {/* {!(values?.fieldType?.value === "Reference") && (
                  // render for every field except reference (2699250881)
                  <div className="form-group col-sm-4 global-fields-checkbox">
                    <Tooltip title="Additional types of lookups for finding an account">
                      <FormControl component="fieldset">
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={(e, value) => {
                                handleChange(e);
                                setFieldValue("lookupField", e.target.checked);
                              }}
                              name="lookupField"
                              checked={values?.lookupField}
                              color="primary"
                            />
                          }
                          label="Lookup"
                          labelPlacement="end"
                        />
                      </FormControl>
                    </Tooltip>
                  </div>
                )} */}
                {fieldType === 'Reference' && (
                  // render for field type reference (2699250881)
                  <>
                    <div className="form-group col-sm-4">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={`${classes.labelName}`}
                        placeholder={`Search Reference`}
                        label="Reference"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        disabled
                        name="dataBaseReference"
                        value={dataBaseValue}
                        required
                        onChange={(e) => {
                          handleChange(e);
                          setDataBaseValue(e.target.value);
                          setFieldValue('dataBaseReference', e.target.value);
                        }}
                        InputProps={{
                          endAdornment: (
                            <Button
                              variant="contained"
                              className={` ${classes.filterGroupButton}`}
                              // onClick={() => setDataBaseReference(true)}
                            >
                              Search
                            </Button>
                          ),
                        }}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched['dataBaseReference']}
                        error={
                          touched && touched['dataBaseReference'] && errors['dataBaseReference']
                        }
                        helperText={
                          touched['dataBaseReference'] &&
                          errors['dataBaseReference'] &&
                          errors['dataBaseReference']
                        }
                      />
                      <FormHelperText>
                        {touched['dataBaseReference'] && errors['dataBaseReference']}
                      </FormHelperText>
                    </div>
                  </>
                )}
                {
                  <>
                    {/* {!view &&
                      !values?.isDropdown &&
                      !(
                        fieldType === "Date" ||
                        fieldType === "SSN" ||
                        fieldType === "Reference" ||
                        fieldType === "Amount" ||
                        fieldType === "Phone"
                      ) &&
                      !(
                        data?.fieldType === "Date" ||
                        data?.fieldType === "SSN" ||
                        data?.fieldType === "Reference" ||
                        data?.fieldType === "Amount" ||
                        data?.fieldType === "Phone"
                      ) && (
                    // render for type dropdown (2699250881)
                      <div className="col-sm-4 custom-list-checkbox form-group global-fields-checkbox">
                        <Tooltip title="User should enter an original value for a specified field">
                          <FormControl component="fieldset">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  onChange={(e, value) => {
                                    handleChange(e);
                                    setFieldValue("isList", e.target.checked);
                                    setIsListValue(e.target.checked);
                                    if (e?.target?.checked) {
                                      setFieldValue(
                                        "minimum",
                                        fieldType === "Amount" || fieldType === "Number"
                                          ? null
                                          : ""
                                      );
                                      setFieldValue("maximum", "");
                                    }
                                  }}
                                  name="isList"
                                  checked={values.isList}
                                  color="primary"
                                />
                              }
                              label="Is List"
                              labelPlacement="end"
                            />
                          </FormControl>
                        </Tooltip>
                      </div>
                    )} */}
                    {isCriteria === 'Y' && !criteriaFieldSelected(formData) &&
                    values.fieldType?.value?.toLowerCase() === 'text' ? (
                        <div className="form-group col-sm-4 ">
                          <FormControl component="fieldset">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  onChange={(e, value) => {
                                    setFieldValue('isCriteriaField', e.target.checked);
                                  }}
                                  name="isCriteriaField"
                                  checked={values.isCriteriaField}
                                  disabled={isAlreadyExtended === 'Y'}
                                />
                              }
                              label="Is Criteria Field"
                              labelPlacement="end"
                            />
                          </FormControl>
                        </div>
                      ) : null}
                    {values?.fieldType?.value !== 'Reference' && values.listType === 'Fixed' && (
                      <div className="form-group col-sm-4">
                        <TextField
                          margin="dense"
                          variant="outlined"
                          className={`${classes.labelName}`}
                          placeholder={`Enter List`}
                          label="List"
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          name="list"
                          required
                          InputProps={{
                            onKeyDown: handleKeyDown,
                          }}
                          value={item}
                          onChange={(e, val) => {
                            handleChange(e);
                            setFieldValue('list', e.target.value);
                            handleItemChange(e);
                          }}
                          onBlur={handleBlur}
                          fullWidth
                          error={items?.length < 1 && touched.list && errors.list}
                        />
                        {items?.length < 1 && (
                          <FormHelperText>
                            {touched.list && errors.list && errors.list}
                          </FormHelperText>
                        )}
                      </div>
                    )}
                    {values?.fieldType?.value !== 'Reference' && values.listType === 'Fixed' && (
                      <div className="col-sm-8 form-group chips-block">
                        {items?.length > 0 &&
                          items?.map((item) => (
                            <div key={item}>
                              <div className="tag-item-chips" key={item}>
                                <div className="chips-content">{item}</div>
                                <button
                                  type="button"
                                  className="chips-close"
                                  onClick={() => handleDelete(item)}
                                >
                                  &times;
                                </button>
                              </div>
                            </div>
                          ))}
                      </div>
                    )}
                    {/* {
                      values.listType === "Fixed" &&
                      !(
                        fieldType === "Date" ||
                        fieldType === "SSN" ||
                        fieldType === "Reference" ||
                        fieldType === "Amount" ||
                        fieldType === "Phone"
                      ) &&
                      !(
                        data?.fieldType === "Date" ||
                        data?.fieldType === "SSN" ||
                        data?.fieldType === "Reference" ||
                        data?.fieldType === "Amount" ||
                        data?.fieldType === "Phone"
                      ) && (
                        <div className="col-sm-4 custom-list-checkbox form-group global-fields-checkbox">
                          <Tooltip title="">
                            <FormControl component="fieldset">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled={values?.isList}
                                    onChange={(e, value) => {
                                      handleChange(e);
                                      // setFieldValue("isList", e.target.checked);
                                      // if (e?.target?.checked) {
                                      //   setFieldValue(
                                      //     "minimum",
                                      //     fieldType === "Amount" || fieldType === "Number"
                                      //       ? null
                                      //       : ""
                                      //   );
                                      // }
                                      setFieldValue("maximum", "");
                                      setFieldValue("minimum", "");
                                      setIsDropdownChecked(e.target.checked);
                                    }}
                                    name="isDropdown"
                                    checked={values.isDropdown}
                                    color="primary"
                                  />
                                }
                                label="Is Dropdown"
                                labelPlacement="end"
                              />
                            </FormControl>
                          </Tooltip>
                        </div>
                      )} */}
                    {values?.fieldType?.value !== 'Reference' && values.listType === 'Dynamic' && (
                      <div className="form-group col-sm-12 col-md-4 col-lg-4 col-xl-4">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="typeCode"
                          size="small"
                          options={typeCodeDropdownData?.length > 0 ? typeCodeDropdownData : []}
                          fullWidth
                          className="select-gender"
                          label="Type Code"
                          required
                          value={values?.typeCode}
                          onBlur={handleBlur}
                          autoHighlight
                          getOptionLabel={(option) =>
                            option?.typeCode && option?.description ?
                              `${option?.typeCode} - ${option?.description}` :
                              option?.typeCode ?
                                option?.typeCode :
                                null
                          }
                          renderInput={(params) => (
                            <GuiTextField
                              {...params}
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              name="typeCode"
                              error={Boolean(touched?.typeCode && errors?.typeCode)}
                              required
                              label="Type"
                              className={`${classes.labelName}`}
                              variant="outlined"
                              margin="dense"
                              placeholder="Select Type"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'off', // disable autocomplete and autofill
                              }}
                            />
                          )}
                          error={touched?.typeCode && errors?.typeCode}
                          touched={touched?.typeCode}
                          onChange={(event, value) => {
                            setFieldValue('typeCode', value);
                          }}
                        />
                        {errors?.typeCode ? (
                          <FormHelperText>{touched.typeCode && errors.typeCode}</FormHelperText>
                        ) : null}
                      </div>
                    )}
                  </>
                }
              </div>

              <>
                <div className={`${componentClasses.taskParameters}`}>
                  <Typography variant="h4" className={classes.legend}>
                    Field Usage{' '}
                  </Typography>
                  <div className="form-row global-field-textfields new-standard-textfields view-label Fieldgroup">
                    {fieldUsage?.map((el, index) => {
                      const {value} = el;
                      return (
                        <FormControl component="fieldset" key={index}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) => {
                                  setFieldValue(value, e.target.checked);
                                }}
                                name={value}
                                checked={values[value]}
                              />
                            }
                            label={value}
                            labelPlacement="end"
                          />
                        </FormControl>
                      );
                    })}
                  </div>
                </div>
              </>
              <div className="form-row global-field-textfields new-standard-textfields view-label">
                {!values?.viewOnly && ['Fixed', 'Dynamic']?.includes(values?.listType) ? (
                  <div className="form-group col-sm-4 col-md-4 col-lg-3  global-fields-checkbox">
                    <Tooltip title="Multiple values can be selected for list type fixed">
                      <FormControl component="fieldset">
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={(e, value) => {
                                handleChange(e);
                                setFieldValue('multiSelect', e.target.checked);
                              }}
                              name="multiSelect"
                              checked={values?.multiSelect}
                            />
                          }
                          label="Multi Select"
                          labelPlacement="end"
                        />
                      </FormControl>
                    </Tooltip>
                  </div>
                ) : (
                  ''
                )}

                {!values?.viewOnly && fieldType !== 'Reference' && (
                  // rendering mandatory field if not view only, type reference (2699250881)
                  <div className="col-sm-4 col-md-4 col-lg-3  global-fields-checkbox">
                    <Tooltip title="When checked, field will be mandatory">
                      <FormControl component="fieldset">
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={(e, value) => {
                                handleChange(e);
                                setFieldValue('mandatory', e.target.checked);
                                if (e.target.checked) {
                                  setFieldValue('viewOnly', false);
                                }
                                if (!e.target.checked) {
                                  setFieldValue('unique', false);
                                }
                              }}
                              name="mandatory"
                              checked={values.mandatory}
                            />
                          }
                          label="Mandatory"
                          labelPlacement="end"
                        />
                      </FormControl>
                    </Tooltip>
                  </div>
                )}
                {!udwView && (
                  // rendering view only checkbox if its not view only window (2699250881)
                  <>
                    <div className="col-sm-4 col-md-4 col-lg-3  global-fields-checkbox">
                      <Tooltip title="When checked, field will be view-only">
                        <FormControl component="fieldset">
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e, value) => {
                                  setFieldValue('minimum', '');
                                  setFieldValue('maximum', '');
                                  handleChange(e);
                                  setView(e.target.checked);
                                  setFieldValue('viewOnly', e.target.checked);
                                  if (e.target.checked) {
                                    setFieldValue('mandatory', false);
                                  }
                                }}
                                name="viewOnly"
                                checked={values.viewOnly}
                              />
                            }
                            disabled={values?.fieldType?.key === 'Reference'}
                            label="View Only"
                            labelPlacement="end"
                          />
                        </FormControl>
                      </Tooltip>
                    </div>
                    {!(values?.fieldType?.value === 'Reference') && (
                      // render audit trail checkbox if field type is not reference (2699250881)
                      <>
                        {/* <div className="col-sm-4 col-md-4 col-lg-3  global-fields-checkbox">
                              <Tooltip title="Tracks changes to data stored">
                                <FormControl component="fieldset">
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        onChange={handleChange}
                                        name="auditTrail"
                                        checked={values.auditTrail}
                                      />
                                    }
                                    label="Audit Trail"
                                    labelPlacement="end"
                                  />
                                </FormControl>
                              </Tooltip>
                            </div> */}
                        <div className="col-sm-4 col-md-4 col-lg-3  global-fields-checkbox">
                          <Tooltip title="When checked, changes made by the user to the data in this field will be logged by the system">
                            <FormControl component="fieldset">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    onChange={(e) => {
                                      handleChange(e);
                                      setFieldValue('isEncrypted', !e.target.checked);
                                      setFieldValue('auditNote', e.target.checked);
                                    }}
                                    name="auditNote"
                                    // disabled={values?.isEncrypted}
                                    checked={values.auditNote}
                                  />
                                }
                                label="Audit Note"
                                labelPlacement="end"
                              />
                            </FormControl>
                          </Tooltip>
                        </div>
                      </>
                    )}

                    {!(values?.fieldType?.value === 'Reference') && (
                      // render audit trail checkbox if field type is not reference (2699250881)
                      <div className="col-sm-4 col-md-4 col-lg-3 global-fields-checkbox">
                        <Tooltip title="When checked, values in this field cannot be used for more than once in the data repository">
                          <FormControl component="fieldset">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue('mandatory', true);
                                    setFieldValue('viewOnly', false);
                                  }}
                                  name="unique"
                                  checked={values.unique}
                                />
                              }
                              label="Unique"
                              labelPlacement="end"
                            />
                          </FormControl>
                        </Tooltip>
                      </div>
                    )}
                    <div className="form-group col-sm-4 col-md-4 col-lg-3  global-fields-checkbox">
                      <Tooltip title="When checked, this field can be used to look up/search for the record">
                        <FormControl component="fieldset">
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e, value) => {
                                  handleChange(e);
                                  setFieldValue('isIndexed', e.target.checked);
                                }}
                                name="isIndexed"
                                checked={values?.isIndexed}
                              />
                            }
                            label="Index"
                            labelPlacement="end"
                          />
                        </FormControl>
                      </Tooltip>
                    </div>
                    <div className="form-group col-sm-4 col-md-4 col-lg-3  global-fields-checkbox">
                      <Tooltip title="When checked, this field will be encrypted in the database">
                        <FormControl component="fieldset">
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e, value) => {
                                  handleChange(e);
                                  setFieldValue('isEncrypted', e.target.checked);
                                  setFieldValue('auditNote', !e.target.checked);
                                }}
                                // disabled={values?.auditNote}
                                name="isEncrypted"
                                checked={values?.isEncrypted}
                              />
                            }
                            label="Is Encrypted"
                            labelPlacement="end"
                          />
                        </FormControl>
                      </Tooltip>
                    </div>
                  </>
                )}
              </div>
              <div className="button-spacing-mb new-standard-textfields">
                <Button
                  type="reset"
                  variant="outlined"
                  className={`reset-btn mx-1 ${classes.buttonRoot}`}
                  onClick={() => {
                    if (isEditOpen) {
                      data['fieldType'] = field;
                      data['globalFieldName'] = dbRef;
                      data?.displayOptions?.isEditable === 'N' && setView(true);
                      setDataBaseValue(data?.globalFieldName);
                      data?.displayOptions?.isEditable === 'Y' && setView(false);
                    } else {
                      !udwView && setView(false);
                      setFieldType('');
                      setDataBaseValue('');
                    }
                  }}
                >
                  Reset
                </Button>
                <Button
                  type="submit"
                  disabled={disableSubmit}
                  variant="outlined"
                  className={`search-btn mx-1 ${classes.buttonRoot}`}
                >
                  Save
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
      {/* <DialogBox
        open={dataBaseReference}
        dialogClose={() => handleDataBaseSearch()}
        title="Add Database Reference"
        maxWidth="lg"
      >
        <SearchDatabaseReference
          handleClose={handleDataBaseSearch}
          setDataBaseValue={setDataBaseValue}
        />
      </DialogBox> */}
    </div>
  );
};

export default FormFields;
